/** @jsxImportSource @emotion/react */

import React, { useEffect } from 'react';
import { RootState } from 'Redux/store';
import { connect } from 'react-redux';
import { IGoldPrice } from 'Redux/slices/home/Entities';
import Actions from 'Redux/Actions';
import { bannerBg, rightToLeft } from '../Styles/BannerStyles';
import Selectors from '../../Redux/Selectors';

interface BannerProps {
    goldPriceLoading: boolean;
    goldPrice: IGoldPrice | undefined;
}

const Banner = (prop: BannerProps): JSX.Element => {
    const { goldPrice, goldPriceLoading } = prop;

    return (
        <div css={bannerBg}>
            <div css={rightToLeft}>
                <p>
                    TIANSI Gold Price Quotes: 999.9 - RM
                    {goldPrice?.gold9999}
                    /G
                    <span style={{ marginLeft: 10, marginRight: 10 }}><img src='/assets/icons/Ellipse1.svg' alt='dot icon' style={{ width: 5, height: 5, marginTop: -6 }} /></span>
                    999 - RM
                    {goldPrice?.gold999}
                    /G
                    <span style={{ marginLeft: 10, marginRight: 10 }}><img src='/assets/icons/Ellipse1.svg' alt='dot icon' style={{ width: 5, height: 5, marginTop: -6 }} /></span>
                    916(A) - RM
                    {goldPrice?.gold916A}
                    /G
                    <span style={{ marginLeft: 10, marginRight: 10 }}><img src='/assets/icons/Ellipse1.svg' alt='dot icon' style={{ width: 5, height: 5, marginTop: -6 }} /></span>
                    916(B) - RM
                    {goldPrice?.gold916B}
                    /G
                </p>
            </div>
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    goldPrice: Selectors.getHomeGoldPrice(state),
    goldPriceLoading: Selectors.getHomeGoldPriceAttempting(state),
});

const mapDispatchToProps = (dispatch: any) => ({
    // jemisysGoldPricing: () => dispatch(Actions.homeGetGoldPrice()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Banner);
